import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "qin-sidebar-wrapper grow_enabled flex relative" }
const _hoisted_2 = { class: "qin-sidebar-layout" }
const _hoisted_3 = {
  class: "qin-sidebar-trigger",
  ref: 'sidebarTrigger'
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "qin-sidebar-trigger__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "qin-sidebar-trigger__image",
    src: "/static/app/quod-light-logo.svg",
    alt: "qin-logo-image"
  })
], -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  class: "qin-sidebar",
  ref: 'sidebar'
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "qin-sidebar__element qin-sidebar__element--header" }, null, -1)
const _hoisted_8 = { class: "qin-sidebar__element qin-sidebar__element--link" }
const _hoisted_9 = { class: "qin-sidebar__subsctiption-wrapper" }
const _hoisted_10 = { class: "qin-sidebar__icon-wrapper" }
const _hoisted_11 = { class: "qin-sidebar__icon" }
const _hoisted_12 = { class: "qin-sidebar__text" }
const _hoisted_13 = {
  key: 0,
  class: "qin-sidebar__notify-quantity"
}
const _hoisted_14 = { class: "qin-sidebar__element qin-sidebar__element--link" }
const _hoisted_15 = { class: "qin-sidebar__subsctiption" }
const _hoisted_16 = { class: "qin-sidebar__subsctiption-wrapper" }
const _hoisted_17 = { class: "qin-sidebar__icon-wrapper" }
const _hoisted_18 = { class: "qin-sidebar__icon" }
const _hoisted_19 = { class: "qin-sidebar__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_route_access = _resolveComponent("route-access")!
  const _component_ui_click_outside = _resolveComponent("ui-click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ui_click_outside, { do: $setup.closeSidebar }, {
        default: _withCtx(({ ref }) => [
          _createElementVNode("div", {
            class: "qin-sidebar-layout__layout-wrapper",
            ref: ref
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "qin-sidebar-trigger__arrow",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleSidebar()))
              }, [
                _createVNode(_component_i_arrow_right)
              ]),
              _hoisted_4,
              _createElementVNode("div", {
                class: "qin-sidebar-trigger__page-title",
                innerHTML: $setup.breadcrumbsLabels[$setup.pageTitle] || $setup.textPageTitle
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", {
                class: "qin-sidebar__element-wrapper",
                onClick: $setup.closeSidebar
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.id
                  }, [
                    (item.link)
                      ? (_openBlock(), _createBlock(_component_route_access, {
                          key: 0,
                          to: {name: item.link}
                        }, {
                          default: _withCtx(({ hasAccess }) => [
                            hasAccess
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "ds-link ds-link--full_width",
                                  to: {name: item.link}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", {
                                        class: "qin-sidebar__subsctiption",
                                        ref_for: true,
                                        ref: 'subscription'
                                      }, [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "button_img" }))
                                        ])
                                      ]),
                                      _createElementVNode("p", _hoisted_12, _toDisplayString(item.title), 1),
                                      (item.counter && item.count)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createElementVNode("span", null, _toDisplayString(item.count), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("div", {
                  class: "ds-link ds-link--full_width",
                  onClick: _withModifiers($setup.logout, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString($setup.$t('Log Out')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent('i-logout'), { class: "button_img" }))
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_19, _toDisplayString($setup.$t('Log Out')), 1)
                  ])
                ])
              ])
            ])
          ], 512)
        ]),
        _: 1
      })
    ])
  ]))
}